import {treeAspect, wikiTab, jobTab} from 'uix/views/utils'

let domainEnabled = ({datatype, treeNode}) =>
  datatype == 10 ||
  treeNode.nodeType == 'domain:all' ||
  treeNode.nodeType.startsWith('domain:byState')

let licencedTab = ({dconfig, user}) => !dconfig.export.basic || user.hasGroup('debug')

export const capsule = {
  cfg: ({iconfig}) => iconfig.preservation?.on,
  ...treeAspect,
  acl: 'g:admin,g:datacurator',
  tabGroup: 'capsule',
  tabs: {
    overview: {
      default: true,
      enabled: domainEnabled,
      parts: [{type: 'CapsuleReport', filters: [{lazy: true, type: 'getCapsuleInfo'}]}],
      minorTabGroup: 'archiving',
      icon: 'overview',
    },

    history: {
      datatype: [10],
      parts: ['CapsuleHistory'],
      minorTabGroup: 'archiving',
      icon: 'clock outline',
    },
    titles: {
      cfg: licencedTab,
      enabled: domainEnabled,
      parts: [
        {
          type: 'CapsuleTitleList',
          filters: [{type: 'getCapsuleTitleList', max: 10000, days: 30}],
        },
      ],
      minorTabGroup: 'automated',
      icon: 'md_document',
    },
    list: {
      enabled: domainEnabled,
      cfg: licencedTab,
      parts: [{type: 'CapsuleList', filters: ['getCapsuleList']}],
      minorTabGroup: 'automated',
      icon: 'box',
    },
    id: {
      datatype: [1],
      parts: [{type: 'CapsuleInfo', filters: ['getSingleCapsuleInfo', 'getLocalCapsules']}],
    },
    transfer: {
      enabled: domainEnabled,
      cfg: licencedTab,
      parts: [
        {
          type: 'TransferInfo',
          filters: [
            {lazy: true, type: 'getEndpointAvailability'},
            {lazy: true, type: 'getCapsuleTransferList'},
          ],
        },
      ],
      minorTabGroup: 'automated',
      icon: 'upload',
    },
    orphans: {
      enabled: domainEnabled,
      cfg: licencedTab,
      parts: [
        {
          type: 'CapsuleList',
          filters: [{lazy: true, type: 'getCapsuleOrphans'}],
        },
      ],
      minorTabGroup: 'automated',
      icon: 'box',
    },
    local: {datatype: [10, 2], cfg: licencedTab, parts: ['LocalCapsules']},
    job: jobTab({names: 'group:export'}),
    config: {datatype: [10], cfg: licencedTab, parts: ['CapsuleConfig']},
    error: {
      datatype: [10],
      cfg: licencedTab,
      parts: [{type: 'SysError', errorTypes: ['zipcapsule']}],
    },
    // start: wikiTab({ident: 'preservation/start', tabGroupDefault: true}),
  },
}
